import { cloneImage, cropImage, localTo } from './image.js';
const CORE_KEYS = ['id', 'storeName', 'bundle', 'price', 'quantity'];
function localCellRects(row) {
    const out = {};
    for (const key of CORE_KEYS)
        out[key] = localTo(row.rect, row.cells[key].rect);
    return out;
}
/** Produce copied row/cell images without altering billion-overlap pixels. */
export function prepareOwlRow(source, row) {
    return {
        index: row.index,
        image: cropImage(source, row.rect),
        cells: localCellRects(row),
        hasBillionPriceOverlap: row.hasBillionPriceOverlap,
    };
}
export function cropPreparedOwlCell(row, key) {
    return cloneImage(cropImage(row.image, row.cells[key]));
}
//# sourceMappingURL=row.js.map